import { classNames } from 'libs/react';
import { useEffect } from 'libs/react';
import { useState } from 'libs/react';
import { DealItemPickerQuerySaleItemSelectPredicate, DealItemPickerQuerySaleItemFieldPredicate, DealItemPickerQuerySaleItemConfigurationPredicate } from './DealItemPickerQueryPredicate';
import { DealItemPickerQuerySaleItemGroupPredicate } from './DealItemPickerQueryPredicate';
import { DealItemPickerQuerySaleItemPricePredicate } from './DealItemPickerQueryPredicate';
import { TransitionItem } from 'components/Transition';
import { Transition } from 'components/transition/Transition';
import { React } from 'libs/react';
import { useUser } from 'components/user/UserProvider';
import './DealItemPickerQueryBuilder.scss';
/**
 * @component DealItemPickerQueryBuilder
 * @since 1.0.0
 */
export function DealItemPickerQueryBuilder(props) {
    var _a, _b, _c;
    const { style, fieldsStep, filterBy, values } = Object.assign({ style: 'normal' }, props);
    const { user } = useUser();
    const [mode, setMode] = useState('enter');
    const [step, setStep] = useState(0);
    const [data, setData] = useState(filterBy !== null && filterBy !== void 0 ? filterBy : {});
    const fields = (_a = fieldsStep === null || fieldsStep === void 0 ? void 0 : fieldsStep.map((fieldStep) => ({
        id: fieldStep.id,
        name: fieldStep.name,
        type: 'sale_item_field',
        inputType: fieldStep.type,
        title: t(`${fieldStep.infos}`),
        entity: fieldStep.group.category
    }))) !== null && _a !== void 0 ? _a : [];
    let steps = [];
    // TODO : Add feature to let the user set the query builder steps
    if (((_b = user === null || user === void 0 ? void 0 : user.session.user.account) === null || _b === void 0 ? void 0 : _b.tag) == 'motrec') {
        steps = [
            {
                id: 'group',
                name: 'group',
                type: 'sale_item_group',
                inputType: 'SELECT_DROPDOWN',
                title: t('What is your primary need ?')
            },
            ...fields
        ];
    }
    else if (((_c = user === null || user === void 0 ? void 0 : user.session.user.account) === null || _c === void 0 ? void 0 : _c.tag) == 'ripplecove') {
        steps = [
            {
                id: 'group',
                name: 'group',
                type: 'sale_item_group',
                inputType: 'SELECT_DROPDOWN',
                title: t('What kind of event ?')
            },
            ...fields
        ];
    }
    else {
        steps = [
            {
                id: 'group',
                name: 'group',
                type: 'sale_item_group',
                inputType: 'SELECT_DROPDOWN',
                title: t('What product category are you looking for ?')
            },
            ...fields
        ];
    }
    /**
     * @function gotoNext
     * @since 1.0.0
     * @hidden
     */
    function gotoNext() {
        setStep(clamp(step + 1, min, max));
        setMode('next');
    }
    /**
     * @function gotoPrev
     * @since 1.0.0
     * @hidden
     */
    function gotoPrev() {
        const nextStep = steps[step];
        setData(Object.assign(Object.assign({}, data), { [nextStep.id]: '' }));
        setStep(clamp(step - 1, min, max));
        setMode('prev');
    }
    /**
     * @function getMinStep
     * @since 1.0.0
     * @hidden
     */
    function getMinStep() {
        return 0;
    }
    /**
     * @function getMax
     * @since 1.0.0
     * @hidden
     */
    function getMaxStep() {
        return steps.length - 1;
    }
    /**
     * @function onChange
     * @since 1.0.0
     * @hidden
     */
    function onChange(name, value) {
        setData(Object.assign(Object.assign({}, data), { [name]: value }));
    }
    /**
     * Invoke the handler.
     * @since 1.0.0
     */
    useEffect(() => {
        if (props.onChange) {
            props.onChange(data);
        }
    }, [data]);
    const min = getMinStep();
    const max = getMaxStep();
    const current = steps[step];
    if (current == null) {
        return null;
    }
    const { id, name, type, inputType, title } = current;
    const next = step < max;
    const prev = step > min;
    const value = data[name];
    const className = classNames('deal-item-picker-browse-query-builder', 'deal-item-picker-browse-query-builder--' + style, 'deal-item-picker-browse-query-builder--' + mode, props.className);
    return (React.createElement("div", { className: className },
        React.createElement(Transition, { appear: false, serial: false },
            React.createElement(TransitionItem, { key: name },
                React.createElement(Predicate, { data: data, id: id, name: name, type: type, inputType: inputType, next: next, prev: prev, title: title, value: value, onPrev: gotoPrev, onNext: gotoNext, onChange: onChange, values: values })))));
}
/**
 * @component Predicate
 * @since 1.0.0
 */
function Predicate(props) {
    const { data, id, name, type, inputType, title, value, next, prev, values, onPrev, onNext, onChange } = props;
    if (type == 'sale_item_configuration') {
        return (React.createElement(DealItemPickerQuerySaleItemConfigurationPredicate, { id: id, name: name, next: next, prev: prev, title: title, value: value, onPrev: onPrev, onNext: onNext, onChange: onChange }));
    }
    if (type == 'sale_item_group') {
        return (React.createElement(DealItemPickerQuerySaleItemGroupPredicate, { id: id, name: name, next: next, prev: prev, title: title, value: value, onPrev: onPrev, onNext: onNext, onChange: onChange }));
    }
    if (type == 'sale_item_field' &&
        (inputType == 'TEXTBOX' || inputType == 'NUMBER')) {
        return (React.createElement(DealItemPickerQuerySaleItemFieldPredicate, { id: id, name: name, next: next, prev: prev, title: title, inputType: inputType, value: data[id], onPrev: onPrev, onNext: onNext, onChange: onChange }));
    }
    if (type == 'sale_item_field' &&
        (inputType == 'SELECT_DROPDOWN' || inputType == 'MULTISELECT')) {
        return (React.createElement(DealItemPickerQuerySaleItemSelectPredicate, { id: id, name: name, next: next, prev: prev, title: title, value: value, onPrev: onPrev, onNext: onNext, onChange: onChange, values: values }));
    }
    if (type == 'sale_item_price') {
        return (React.createElement(DealItemPickerQuerySaleItemPricePredicate, { id: id, name: name, next: next, prev: prev, title: title, value: value, onPrev: onPrev, onNext: onNext, onChange: onChange }));
    }
    return null;
}
/**
 * @function clamp
 * @since 1.0.0
 * @hidden
 */
function clamp(value, min, max) {
    if (value < min)
        value = min;
    if (value > max)
        value = max;
    return value;
}
